// loader.component.ts
import { Component } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';


@Component({
  selector: 'app-loader',
  template: `
    <div class="loader-container" *ngIf="loaderService.isLoading | async">
    <img src="assets/images/DigiCompany_loader.png" class="spinner" alt="Loading..." />
  </div>
  `,
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
